
  import Vue from 'vue';
  import Card from '@/models/card';

  export default Vue.extend({
    name: 'CardList',
    props: ['cards', 'query', 'cardWidth'],
    components: {
      Card: () => import ('@/components/Card.vue'),
    },
    methods: {
      onClick(card: Card) {
        this.$emit('clicked', card);
      },
      matchQuery(card: Card): boolean {
        const target = [
          card.title,
          card.subtitle,
          card.metadata,
        ].join('  ').toLowerCase();
        let match = true;
        for (const keyword of this.query.toLowerCase().split(/\s/)) {
          match = match && (target.indexOf(keyword) >= 0);
        }
        return match;
      }
    },
  })
